// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { TECFinanceCompanyModel } from "@store/Framework/Types/ApiModels";
import { GetTECFinanceCompaniesApiParameter } from "@store/Framework/Services/TaxExemptionCertificatesService";
import TECFinanceCompaniesState from "@store/Framework/Store/Greif/Data/TECFinanceCompanies/TECFinanceCompaniesState";
import { Draft } from "immer";

const initialState: TECFinanceCompaniesState = {
    isLoading: {},
    byId: {},
    dataViews: {},
};

const actions = {
    "Greif/Data/TECFinanceCompanies/BeginLoadTECFinanceCompanies": (
        draft: Draft<TECFinanceCompaniesState>,
        action: { parameter: GetTECFinanceCompaniesApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Greif/Data/TECFinanceCompanies/CompleteLoadTECFinanceCompanies": (
        draft: Draft<TECFinanceCompaniesState>,
        action: {
            parameter: GetTECFinanceCompaniesApiParameter;
            collection: TECFinanceCompanyModel;
        },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.collection, collection => Object(collection)!);

        if (draft.failedToLoadTECFinanceCompanies) {
            draft.failedToLoadTECFinanceCompanies = false;
        }
    },

    "Greif/Data/TECFinanceCompanies/FailedToLoadTECFinanceCompanies": (draft: Draft<TECFinanceCompaniesState>) => {
        draft.failedToLoadTECFinanceCompanies = true;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifDataTECFinanceCompaniesActions = Parameters<typeof reducer>[1];
export default reducer;
